module.exports = __webpack_public_path__ + "035ae962.woff2";